export default () => ({
  tokens: {
    access: "",
    refresh: "",
    tempAccess: "",
    tempRefresh: "",
  },
  status: 0,
  plaidToken: "",
  userId: 0,
  isGuestUser: false,
  userEmail: "",
  paymentCompleted: 0,
  restoredData: "",
  ssoUser: 0,
});
